var React = require('react');
var axios = require('axios');
// var jwtDecode = require('jwt-decode');
var {Route, Router, IndexRoute,  Link,hashHistory, browserHistory} = require('react-router');
var Navigatable = require('react-router-component').NavigatableMixin;
var STORAGE_KEY = 'id_token';
var Login = React.createClass({
mixins: [ Navigatable ],
    getInitialState: function() {
        return {
            email: '',
            password: '',
            loading: false,
            message:'',
            token:''
        };
    },

    componentDidMount: function() {},

    onEmailChange: function(e) {
        this.setState({
            email: e.target.value
        });
    },
    onPasswordChange: function(e) {
        this.setState({
            password: e.target.value
        });
    },
   _onValueChange: function(item, selectedValue) {
        try {
            localStorage.setItem(item, selectedValue);
        } catch (error) {
            console.log('localStorage errors: ' + error.message);
        }
    },
    onSave: function(e) {
       var _this = this;
       this.setState({loading: true});
        axios.post('/api/v1/login', {
            email: this.state.email,
            password: this.state.password,

          }, {headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }})
          .then(function (response) {

              _this._onValueChange(STORAGE_KEY, response.data.token);

            _this.setState({
                category_name: '',
                 email: "",
                password: "",
                loading: false,
            });
             {/*window.location.href = 'http://localhost:8000/#/categories';*/}
             hashHistory.push('/categories');
          })
          .catch(function (error) {
             _this.setState({
                 message:'Wrong email/password',
            loading: false,})
          });
        
        e.preventDefault();
    },
    renderLoading:function() {
    return (<div><img className="center-block" src="/images/preloader.gif"/></div>);
  },

    render: function() {

        return (
        	<div className="wrapper-page">

                            <div className="m-t-40 account-pages">
                                <div className="text-center account-logo-box">
                                    <h2 className="text-uppercase">
                                        <a href="index-2.html" className="text-success">
                                            {/* <span><img src="assets/images/logo.png" alt="" height="36"/></span>*/}
                                            Quiz
                                        </a>
                                    </h2>
                                    
                                </div>
                                <div className="account-content">
                                    <h3 className="text-custom">{this.state.loading ? this.renderLoading():""}</h3>
                                    <p className="text-custom text-center">{this.state.message ? this.state.message:""}</p>
                                    <form className="form-horizontal" onSubmit={this.onSave}>

                                        <div className="form-group ">
                                            <div className="col-xs-12">
                                                <input className="form-control" type="email" value={this.state.email}
            required="required"
            onChange={this.onEmailChange} placeholder="Email"/>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="col-xs-12">
                                                <input className="form-control" type="password"
            value={this.state.password}
                                                       required="required"
            onChange={this.onPasswordChange} placeholder="Password"/>
                                            </div>
                                        </div>

                                        <div className="form-group account-btn text-center m-t-10">
                                            <div className="col-xs-12">
                                                <button className="btn w-md btn-bordered btn-danger waves-effect waves-light" onClick={this.onSave}>Log In</button>
                                            </div>
                                        </div>

                                    </form>

                                    <div className="clearfix"></div>
                                    

                                </div>
                            </div>
                          

                        </div>
      
            );
    }

});


module.exports = Login;


// WEBPACK FOOTER //
// ./react/app/components/Login.jsx